import { formatPercentage, formatTextEllipsis, formatValueWithCompactNumber } from '@/lib/format';
import { useTradeStore } from '@/page/trade/store';
import { IHolder } from '@/request/token/token.response.interface';
import BigNumber from 'bignumber.js';

interface IProps {
  holder: IHolder;
}

export default (props: IProps) => {
  const { holder } = props;
  const { tokenInfo } = useTradeStore();
  const percent = tokenInfo?.address ? BigNumber(holder.position).div(tokenInfo?.totalSupply).toString() : 0;
  const balance = tokenInfo?.address ? BigNumber(holder.position).times(tokenInfo?.price).toString() : 0;
  return (
    <div className="border-b border-borderColor flex items-center h-[72px] text-[12px]">
      <div className="flex-1">{formatTextEllipsis(holder.walletAddress)}</div>
      <div className="flex-1 text-center"> {formatValueWithCompactNumber(balance, true)}</div>
      <div className="flex-1 text-right">{formatPercentage(percent, { showPositiveSign: false, scale: true })}</div>
    </div>
  );
};
